export class ModalOptions {
  title?: string = 'Modal Header';
  showSave?: boolean = true;
  showCancel?: boolean = true;
  showCross?: boolean = true;
  showFullscreen?: boolean = false;
  saveText?: string = 'Save';
  cancelText?: string = 'cancel';
  centered?: boolean = false;
  scrollable?: boolean = false;
  ignoreBackdropClick?: boolean = false;
  windowClass?: string = "modal-standard";
  required?: boolean = true;
}
